module.exports = require('../../es/symbol/iterator');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/symbol/iterator.js
// module id = 246
// module chunks = 1